<template>
  <main class="main main--help">
    <div class="help">
      <div class="help__content">
        <h1 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h1 mt mb2">Help us understand a little more about what you’re going through</h1>
        <p class="p fw-bold">Are you experiencing either of these?</p>

        <ul class="mb">
          <li class="li">Any type of violence</li>
          <li class="li">Thoughts of hurting yourself or others</li>
        </ul>

        <module-button
          button="primary"
          @click.native="nextQuestion"
          label="No, I am not"
        />

        <module-button
          button="primary"
          link="risk"
          label="Yes, I am"
        />
      </div>

      <div class="help__img">
        <img :src="illustration" alt="">
      </div>
    </div>
  </main>
</template>

<script>
// Images
import help from 'images/illustrations/help.png';

const illustration = help;
import { mapGetters, mapActions } from 'vuex';
import { HTTP } from 'api/http';
import { getLastQuestionId } from 'utils/questionnaire';

// Mixins
import MixinIntakeProgress from 'components/IntakeProgress';

export default {
  name: 'help-myself',

  // Mixins
  mixins: [
    MixinIntakeProgress,
  ],

  // Data
  data() {
    return {
      illustration,
    };
  },

  // computed
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('app', [
      'org',
    ]),
  },

  methods: {
    ...mapActions('questions', [
      'requestSingleQuestion',
    ]),
    ...mapActions('app', ['setErrorMessage', 'setErrorRedirect']),

    nextQuestion() {

      const complaint = JSON.parse(localStorage.getItem('objectComplaint'));
      const answerComplaint = localStorage.getItem('answerComplaint');

      const choices = complaint.choices;

      if (
        (localStorage.getItem('answerComplaint') === 'Alcohol or Drug use' || localStorage.getItem('answerSecondaryComplaint') === 'Alcohol or Drug use') &&
        this.org.show_safety_screen === true
      ) {
        this.$router.push({ name: 'safety-screen' });
      } else {
        choices.forEach((item) => {
          if (answerComplaint === item.text) {
            if (item.next_question) {
              const questionId = getLastQuestionId('f2f') || getLastQuestionId('intakeDetail');

              this.requestSingleQuestion(item.next_question)
                .then(res => {
                  const routeName = getLastQuestionId('f2f') ? 'face-2-face' : 'support-detail';
                  this.$router.push({ name: routeName, params: { id: questionId || res.data.id } });
                })
                .catch(err => (err));
            } else {
              this.$router.push('results');
            }
          }
        });
      }
    },
  },

  created() {
    delete HTTP.defaults.headers.common.Authorization;

    if ( !this.isAuthenticated ) {
      this.checkIntakeRequirements('default', null, null, 'support');

      return;
    }

    this.$router.push({ name: 'home' });
  },
};

</script>



// WEBPACK FOOTER //
// HelpMyself.vue?add9f4e0